<div class="form-group m-form__group row " [formGroup]="eviedenceForm">
	<ng-container>
		<label class="col-lg-4 col-form-label ">
			Non-Assessor App Assessments:
			<span class="astrickColor">*</span>
		</label>
		<div class="form-group m-form__group row ">
			<div class="col-lg-9">
				<select formControlName="reason" class="form-control m-input notranslate">
					<option value="" disabled selected>Select Non-Assessor App Assessments</option>
					<option value="Biometric device not working">Biometric device not working</option>
					<option value="Authentication issue">Authentication issue</option>
					<option value="RD service issue / not working">RD service issue / not working</option>
					<option value="OTG cable not working">OTG cable not working</option>
					<option value="UIDAI server down/ SIP Server/Hardshell Server not responding">UIDAI server down/ SIP
						Server/Hardshell Server not responding</option>
					<option value="Lack of Internet connectivity">Lack of Internet connectivity</option>
					<option value="Aadhar Exempted States">Aadhar Exempted States</option>
					<option value="Proctor Based Assessment">Proctor Based Assessment</option>
					<option value="Others">Others</option>
				</select>
				<app-form-control-messages [control]="eviedenceForm.get( 'reason') "
					[name]=" 'Non-Assessor App Assessments'"></app-form-control-messages>
			</div>
		</div>

		<div *ngIf="eviedenceForm.get('reason').value === 'Others'" class="form-group m-form__group row col-12">
			<label class="col-lg-4 col-form-label">
				Reason:
				<span class="astrickColor">*</span>
			</label>
			<div class="col-lg-4 ">
				<input type="text " class="form-control m-input notranslate" placeholder="Enter Reason" maxlength="150"
					formControlName="otherReason">
				<app-form-control-messages [control]="eviedenceForm.get('otherReason') " [name]=" 'Other Reason'">
				</app-form-control-messages>
			</div>
		</div>
	</ng-container>
	<!-- Document One For TC -->
	<hr>
	<ng-container *ngIf="!isSubmitted">
		<ng-container *ngIf="isAssessor()">
			<div class="form-group m-form__group row col-12">
				<label style="font-weight: bold;" class="col-lg-4 col-form-label">
					1. TC/Location Premises:
					<span class="astrickColor">*</span>
				</label>
				<div>
				</div>
				<div class="form-group m-form__group row col-12">
					<label class="col-lg-4 col-form-label">
						1.1 Photograph 1
						<span class="astrickColor">*</span>
					</label>
					<div>
						<app-file-upload [fileValidation]="tcPerMisesDocumentOne" [multiColumn]="12"
							(fileUploaded)="fileUploaded($event, 'tcPermises' ,'one')"
							(fileUploadCancelled)="onFileUploadCancel($event,'tcPermises', 'one')"></app-file-upload>
					</div>
					<app-form-control-messages [control]="eviedenceForm.get('tcPerMisesPicOne') " [name]=" 'Document'">
					</app-form-control-messages>

				</div>
			</div>

			<ng-container *ngIf="!isSubmitted">

				<!-- Document Two For TC -->
				<div class="form-group m-form__group row col-12">
					<label class="col-lg-4 col-form-label">
						1.2 Photograph 2
						<span class="astrickColor">*</span>
					</label>
					<div>
						<app-file-upload [fileValidation]="tcPerMisesDocumentTwo" [multiColumn]="12"
							(fileUploaded)="fileUploaded($event,'tcPermises', 'two')"
							(fileUploadCancelled)="onFileUploadCancel($event,'tcPermises' ,'two')"></app-file-upload>
					</div>
					<app-form-control-messages [control]="eviedenceForm.get('tcPerMisesPicTwo') " [name]=" 'Document'">
					</app-form-control-messages>
				</div>

				<!-- Group Photograph -->
				<div class="form-group m-form__group row col-12">

					<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && isSubmittedDoc()" class="form-group m-form__group row col-12"> -->
					<label style="font-weight: bold;" class="col-lg-4 col-form-label">
						2. Group Photograph
						<span class="astrickColor">*</span>
					</label>
					<div>
						<app-file-upload [fileValidation]="groupPhotoGraph" [multiColumn]="12"
							(fileUploaded)="fileUploaded($event,'groupPhotoGraph', 'null')"
							(fileUploadCancelled)="onFileUploadCancel($event,'groupPhotoGraph' ,'null')">
						</app-file-upload>
					</div>
					<app-form-control-messages [control]="eviedenceForm.get('groupPhotoGraph') " [name]=" 'Document'">
					</app-form-control-messages>
				</div>

				<div class="form-group m-form__group row col-12">

					<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && eviedenceForm.get('groupPhotoGraph').value" class="form-group m-form__group row col-12"> -->
					<label style="font-weight: bold;" class="col-lg-4 col-form-label">
						3. Photos during assessment at regular intervals (5 Pictures)
						<span class="astrickColor">*</span>
					</label>
					<div>

					</div>
					<!-- interval upload one -->
					<div class="form-group m-form__group row col-12">

						<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && eviedenceForm.get('groupPhotoGraph').value && isSubmittedDoc()" class="form-group m-form__group row col-12"> -->
						<label style="font-weight: bold;" class="col-lg-4 col-form-label">
							3.1. Photograph 1
							<span class="astrickColor">*</span>
						</label>
						<div>
							<app-file-upload [fileValidation]="regularIntervalPicOne" [multiColumn]="12"
								(fileUploaded)="fileUploaded($event,'intervalsPic', 'one')"
								(fileUploadCancelled)="onFileUploadCancel($event,'intervalsPic' ,'one')">
							</app-file-upload>
						</div>
						<app-form-control-messages [control]="eviedenceForm.get('regularIntervalPicOne') "
							[name]=" 'Document'"></app-form-control-messages>
					</div>

					<!-- interval upload two -->
					<div class="form-group m-form__group row col-12">

						<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && eviedenceForm.get('groupPhotoGraph').value" class="form-group m-form__group row col-12"> -->
						<label style="font-weight: bold;" class="col-lg-4 col-form-label">
							3.2. Photograph 2
							<span class="astrickColor">*</span>
						</label>
						<div>
							<app-file-upload [fileValidation]="regularIntervalPicTwo" [multiColumn]="12"
								(fileUploaded)="fileUploaded($event,'intervalsPic', 'two')"
								(fileUploadCancelled)="onFileUploadCancel($event,'intervalsPic' ,'two')">
							</app-file-upload>
						</div>
						<app-form-control-messages [control]="eviedenceForm.get('regularIntervalPicTwo') "
							[name]=" 'Document'"></app-form-control-messages>
					</div>

					<!-- interval upload three-->
					<div class="form-group m-form__group row col-12">

						<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && eviedenceForm.get('groupPhotoGraph').value" class="form-group m-form__group row col-12"> -->
						<label style="font-weight: bold;" class="col-lg-4 col-form-label">
							3.3. Photograph 3
							<span class="astrickColor">*</span>
						</label>
						<div>
							<app-file-upload [fileValidation]="regularIntervalPicThree" [multiColumn]="12"
								(fileUploaded)="fileUploaded($event,'intervalsPic', 'three')"
								(fileUploadCancelled)="onFileUploadCancel($event,'intervalsPic' ,'three')">
							</app-file-upload>
						</div>
						<app-form-control-messages [control]="eviedenceForm.get('regularIntervalPicThree') "
							[name]=" 'Document'"></app-form-control-messages>
					</div>

					<!-- interval upload four-->
					<div class="form-group m-form__group row col-12">

						<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && eviedenceForm.get('groupPhotoGraph').value" class="form-group m-form__group row col-12"> -->
						<label style="font-weight: bold;" class="col-lg-4 col-form-label">
							3.4. Photograph 4
							<span class="astrickColor">*</span>
						</label>
						<div>
							<app-file-upload [fileValidation]="regularIntervalPicFour" [multiColumn]="12"
								(fileUploaded)="fileUploaded($event,'intervalsPic', 'four')"
								(fileUploadCancelled)="onFileUploadCancel($event,'intervalsPic' ,'four')">
							</app-file-upload>
						</div>
						<app-form-control-messages [control]="eviedenceForm.get('regularIntervalPicFour') "
							[name]=" 'Document'"></app-form-control-messages>
					</div>


					<!-- interval upload five-->
					<div class="form-group m-form__group row col-12">

						<!-- <div *ngIf="eviedenceForm.get('tcPerMisesPicOne').value && eviedenceForm.get('tcPerMisesPicTwo').value && eviedenceForm.get('groupPhotoGraph').value" class="form-group m-form__group row col-12"> -->
						<label style="font-weight: bold;" class="col-lg-4 col-form-label">
							3.5. Photograph 5
							<span class="astrickColor">*</span>
						</label>
						<div>
							<app-file-upload [fileValidation]="regularIntervalPicFive" [multiColumn]="12"
								(fileUploaded)="fileUploaded($event,'intervalsPic', 'five')"
								(fileUploadCancelled)="onFileUploadCancel($event,'intervalsPic' ,'five')">
							</app-file-upload>
						</div>
						<app-form-control-messages [control]="eviedenceForm.get('regularIntervalPicFive') "
							[name]=" 'Document'"></app-form-control-messages>
					</div>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>


	<!-- For other user ( AA & SSC ) -->

	<ng-container *ngIf="isUploadEvidenceByAA() || isSubmitted">
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				1. TC/Location Premises:
				<span class="astrickColor">*</span>
			</label>
			<div>

			</div>
		</div>
		<div class="form-group m-form__group row col-12">
			<label class="col-lg-4 col-form-label">
				1.1 Photograph 1
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.tcPerMisesPicOne, 'tcPerMisesPicOne')"
				(mouseleave)="addClickEvent($event, signedUrl.tcPerMisesPicOne, 'tcPerMisesPicOne')"
				(mousemove)="addClickEvent($event, signedUrl.tcPerMisesPicOne, 'tcPerMisesPicOne')"
				(click)="addClickEvent($event, signedUrl.tcPerMisesPicOne, 'tcPerMisesPicOne')" class="border-design">
				<img class="img-size" *ngIf="!renderControl.tcPerMisesPicOne" [src]="signedUrl.tcPerMisesPicOne">
				<img height="500px" *ngIf="renderControl.tcPerMisesPicOne" [src]="signedUrl.tcPerMisesPicOne">


			</div>
		</div>


		<!-- Document Two For TC -->
		<div class="form-group m-form__group row col-12">
			<label class="col-lg-4 col-form-label">
				1.2 Photograph 2
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.tcPerMisesPicTwo, 'tcPerMisesPicTwo')"
				(mouseleave)="addClickEvent($event,signedUrl.tcPerMisesPicTwo, 'tcPerMisesPicTwo')"
				(mousemove)="addClickEvent($event, signedUrl.tcPerMisesPicTwo, 'tcPerMisesPicTwo')"
				(click)="addClickEvent($event, signedUrl.tcPerMisesPicTwo, 'tcPerMisesPicTwo')" class="border-design">
				<img class="img-size" *ngIf="!renderControl.tcPerMisesPicTwo" [src]="signedUrl.tcPerMisesPicTwo">
				<img height="500px" *ngIf="renderControl.tcPerMisesPicTwo" [src]="signedUrl.tcPerMisesPicTwo">

			</div>
		</div>

		<!-- Group Photograph -->
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				2. Group Photograph
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.groupPhotoGraph, 'groupPhotoGraph')"
				(mouseleave)="addClickEvent($event, signedUrl.groupPhotoGraph, 'groupPhotoGraph')"
				(mousemove)="addClickEvent($event, signedUrl.groupPhotoGraph, 'groupPhotoGraph')"
				(click)="addClickEvent($event, signedUrl.groupPhotoGraph, 'groupPhotoGraph')" class="border-design">
				<img class="img-size" *ngIf="!renderControl.groupPhotoGraph" [src]="signedUrl.groupPhotoGraph">
				<img style="height: 500px;" *ngIf="renderControl.groupPhotoGraph" [src]="signedUrl.groupPhotoGraph">

			</div>
		</div>

		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				3. Photos during assessment at regular intervals (5 Pictures)
				<span class="astrickColor">*</span>
			</label>

		</div>
		<!-- interval upload one -->
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				3.1. Photograph 1
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.regularIntervalPicOne, 'regularIntervalPicOne')"
				(mouseleave)="addClickEvent($event, signedUrl.regularIntervalPicOne, 'regularIntervalPicOne')"
				(mousemove)="addClickEvent($event, signedUrl.regularIntervalPicOne, 'regularIntervalPicOne')"
				(click)="addClickEvent($event, signedUrl.regularIntervalPicOne, 'regularIntervalPicOne')"
				class="border-design">
				<img class="img-size" *ngIf="!renderControl.regularIntervalPicOne"
					[src]="signedUrl.regularIntervalPicOne">
				<img style="height:500px" *ngIf="renderControl.regularIntervalPicOne"
					[src]="signedUrl.regularIntervalPicOne">

			</div>
		</div>

		<!-- interval upload two -->
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				3.2. Photograph 2
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.regularIntervalPicTwo, 'regularIntervalPicTwo')"
				(mouseleave)="addClickEvent($event, signedUrl.regularIntervalPicTwo, 'regularIntervalPicTwo')"
				(mousemove)="addClickEvent($event, signedUrl.regularIntervalPicTwo, 'regularIntervalPicTwo')"
				(click)="addClickEvent($event, signedUrl.regularIntervalPicTwo, 'regularIntervalPicTwo')"
				class="border-design">
				<img class="img-size" *ngIf="!renderControl.regularIntervalPicTwo"
					[src]="signedUrl.regularIntervalPicTwo">
				<img style="height:500px" *ngIf="renderControl.regularIntervalPicTwo"
					[src]="signedUrl.regularIntervalPicTwo">

			</div>
		</div>


		<!-- interval upload three-->
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				3.3. Photograph 3
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.regularIntervalPicThree, 'regularIntervalPicThree')"
				(mouseleave)="addClickEvent($event, signedUrl.regularIntervalPicThree, 'regularIntervalPicThree')"
				(mousemove)="addClickEvent($event, signedUrl.regularIntervalPicThree, 'regularIntervalPicThree')"
				(click)="addClickEvent($event, signedUrl.regularIntervalPicThree, 'regularIntervalPicThree')"
				class="border-design">
				<img class="img-size" *ngIf="!renderControl.regularIntervalPicThree"
					[src]="signedUrl.regularIntervalPicThree">
				<img style="height:500px" *ngIf="renderControl.regularIntervalPicThree"
					[src]="signedUrl.regularIntervalPicThree">

			</div>
		</div>
		<!-- interval upload four-->
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				3.4. Photograph 4
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.regularIntervalPicFour, 'regularIntervalPicFour')"
				(mouseleave)="addClickEvent($event,  signedUrl.regularIntervalPicFour, 'regularIntervalPicFour')"
				(mousemove)="addClickEvent($event,  signedUrl.regularIntervalPicFour, 'regularIntervalPicFour')"
				(click)="addClickEvent($event,  signedUrl.regularIntervalPicFour, 'regularIntervalPicFour')"
				class="border-design">
				<img class="img-size" *ngIf="!renderControl.regularIntervalPicFour"
					[src]="signedUrl.regularIntervalPicFour">
				<img style="height:500px" *ngIf="renderControl.regularIntervalPicFour"
					[src]="signedUrl.regularIntervalPicFour">

			</div>
		</div>


		<!-- interval upload five-->
		<div class="form-group m-form__group row col-12">
			<label style="font-weight: bold;" class="col-lg-4 col-form-label">
				3.5. Photograph 5
				<span class="astrickColor">*</span>
			</label>
			<div (mouseenter)="addClickEvent($event, signedUrl.regularIntervalPicFive, 'regularIntervalPicFive')"
				(mouseleave)="addClickEvent($event, signedUrl.regularIntervalPicFive, 'regularIntervalPicFive')"
				(mousemove)="addClickEvent($event,  signedUrl.regularIntervalPicFive, 'regularIntervalPicFive')"
				(click)="addClickEvent($event,  signedUrl.regularIntervalPicFive, 'regularIntervalPicFive')"
				class="border-design">
				<img class="img-size" *ngIf="!renderControl.regularIntervalPicFive"
					[src]="signedUrl.regularIntervalPicFive">
				<img style="height:500px" *ngIf="renderControl.regularIntervalPicFive"
					[src]="signedUrl.regularIntervalPicFive">

			</div>
		</div>
	</ng-container>
	<div class="modal-footer col-lg-12">
		<ng-container *ngIf="isSubmitAllowed()">
			<ng-container *ngIf="!isSubmitted">
				<button *ngIf="isAssessor()" type="button" class="btn btn-primary"
					[disabled]="eviedenceForm.status === 'INVALID'" (click)="submit('SUBMITTED')">Submit</button>
				<button *ngIf="isAssessor()" type="button" class="btn btn-primary" [disabled]="isAllFieldEmpty()"
					(click)="submit('PENDING')">Save As Draft</button>
			</ng-container>
		</ng-container>

		<ng-container *ngIf="isSSCSendBack()">
			<ng-container *ngIf="isNotAssessor()">
				<ng-container *ngIf="isNotProctor()">
					<button type="button" *ngIf="isNotShowButton()" class="btn btn-primary"
						(click)="takeAction('ACCEPT')">Approve</button>
					<button type="button" *ngIf="isNotShowButton()" class="btn btn-primary"
						(click)="takeAction('SENDBACK')">Send Back</button>
					<button type="button" *ngIf="isNotShowButton()" class="btn btn-primary"
						(click)="takeAction('REJECT')">Reject</button>
				</ng-container>
			</ng-container>
		</ng-container>


		<button type="button" class="btn btn-secondary" (click)="close()">Close</button>
	</div>
</div>
<div appSweetAlert></div>